module.exports = __webpack_public_path__ + "static/media/logo.491ca679.png";